import CheckBoxRadio from "../../CheckBoxRadio"
import Typography from "../../Typography"
import CircularProgress from "../../CircularProgress"

export default function RadioGroupBase({ valorInputRadio, setValorInputRadio, placeholder, opcoes, carregando = false, children, group }) {
    return (

            <div className="flex w-full grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
                <Typography component="body1-semibold">{placeholder}</Typography>

                <div className="w-full flex justify-between">

                    <div className="justify-start items-start gap-5 inline-flex">
                        {opcoes?.map((o, index) => <div key={`${group}_${index}`}>
                            <CheckBoxRadio
                                onChange={(e) => { setValorInputRadio(e.target.value) }}
                                disabled={carregando}
                                label={o.titulo}
                                value={o.valor}
                                checked={o.valor == valorInputRadio}
                                name={group}
                            />
                        </div>)}
                    </div>
                    {carregando && <div className="grid h-5 w-5 text-blue-gray-500 place-items-center">
                        <CircularProgress />
                    </div>}

                </div>
                {children}
            </div>

    )
}